import { createFileRoute } from '@tanstack/react-router'

import { PlatformAnnouncementCreationPage } from '../../../components/pages/backoffice/platform/platform-announcements-page/platform-announcement-form-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/announcements/new')({
  component: () => (
    <PermissionChecker requiredPermissions={['backofficeAnnouncement.create']}>
      <PlatformAnnouncementCreationPage />
    </PermissionChecker>
  ),
})
